<template>
  <div>
    <!-- Modal de Login Moderno -->
    <div v-if="showLoginModal" class="login-modal-overlay" @click="fecharModal">
      <div class="login-modal-content" @click.stop>
        <div class="login-header">
          <div class="login-icon">
            <i class="fas fa-user-circle"></i>
          </div>
          <h4 class="login-title">Área do Candidato</h4>
          <p class="login-subtitle">Faça login para acessar sua conta</p>
          <button @click="fecharModal" class="close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="login-body">
          <form @submit.prevent="logar" class="login-form">
            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-envelope me-2"></i>E-mail
              </label>
              <div class="input-group">
                <input
                  v-model="form.email"
                  type="email"
                  class="form-control"
                  placeholder="Digite seu e-mail"
                  required
                  :disabled="loading"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-lock me-2"></i>Senha
              </label>
              <div class="input-group">
                <input
                  v-model="form.senha"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Digite sua senha"
                  required
                  :disabled="loading"
                />
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="togglePassword"
                  :disabled="loading"
                >
                  <i :class="['fas', showPassword ? 'fa-eye-slash' : 'fa-eye']"></i>
                </button>
              </div>
            </div>

            <div class="form-actions">
              <button
                type="submit"
                class="btn btn-primary btn-login"
                :disabled="!isEnabled || loading"
              >
                <i v-if="loading" class="fas fa-spinner fa-spin me-2"></i>
                <i v-else class="fas fa-sign-in-alt me-2"></i>
                {{ loading ? "Entrando..." : "Entrar" }}
              </button>
            </div>

            <div class="login-footer">
              <button
                type="button"
                class="btn btn-link btn-recover"
                @click="recuperarSenha"
                :disabled="loading"
              >
                <i class="fas fa-key me-1"></i>
                Esqueci minha senha
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginComp",
  data() {
    return {
      form: {
        email: "",
        senha: "",
        id: false
      },
      showPassword: false,
      showLoginModal: true,
      loading: false
    };
  },
  computed: {
    isEnabled() {
      return this.form.email && this.form.senha;
    }
  },
  methods: {
    fecharModal() {
      this.$emit('close-modal');
    },



    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    async recuperarSenha() {
      if (!this.form.email) {
        return this.$sweet.sweetNotification("Por favor, digite seu e-mail no campo acima para recuperar a senha.", "warning");
      }

      const { value } = await this.$sweet.sweetQuestionPersonalizado(
        "Recuperar Senha",
        `Deseja recuperar sua senha? Um novo acesso será enviado para o e-mail: ${this.form.email}`,
        "Sim, Recuperar"
      );

      if (!value) return;

      this.$sweet.sweetWait("Processando recuperação de senha...");
      
      try {
        const response = await axios.post("/ps/candidato/recuperar-senha", { 
          email: this.form.email 
        });

        if (response.status === 200) {
          this.$sweet.sweetSuccess("Uma nova senha foi enviada para seu e-mail. Verifique sua caixa de entrada e spam.");
          this.form.senha = ""; // Limpa o campo de senha
        } else {
          this.$sweet.sweetNotification("Erro ao recuperar senha.", "error");
        }
      } catch (error) {
        if (error.response?.status === 404) {
          this.$sweet.sweetNotification("E-mail não encontrado em nosso sistema.", "error");
        } else {
          this.$sweet.sweetNotification(
            error.response?.data?.error || "Erro ao processar solicitação. Tente novamente mais tarde.", 
            "error"
          );
        }
      }
    },

    async logar() {
      if (!this.form.email || !this.form.senha) return;

      this.loading = true;
      this.$sweet.sweetWait("Validando seu acesso...");

      try {
        const response = await axios.post("/ps/candidato/login", this.form);

        if (response.data.token) {
          const token = response.data.token;

          // Salva no localStorage
          axios.defaults.headers["Authorization"] = `Bearer ${token}`;
          localStorage.setItem(`token-${this.$city}`, token);

          this.$sweet.sweetSuccess("Login realizado com sucesso!");

          this.$emit("close-modal");
          this.$router.push({ name: "area-incricao" });
        } else {
          this.$sweet.sweetNotification("Credenciais inválidas!", "error");
        }
      } catch (error) {
        this.$sweet.sweetNotification("Erro ao realizar login.", "error");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>


<style lang="sass" scoped>
.login-modal-overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(0, 0, 0, 0.6)
  display: flex
  justify-content: center
  align-items: flex-start
  z-index: 1050
  backdrop-filter: blur(5px)
  overflow-y: auto
  padding-top: 50px

.login-modal-content
  background: white
  border-radius: 20px
  width: 90%
  max-width: 450px
  max-height: 90vh
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2)
  overflow-y: auto
  animation: slideInUp 0.3s ease-out
  position: relative
  z-index: 1051
  display: flex
  flex-direction: column

@keyframes slideInUp
  from
    opacity: 0
    transform: translateY(-30px)
  to
    opacity: 1
    transform: translateY(0)

.login-header
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  color: white
  padding: 20px
  text-align: center
  position: relative

.login-icon
  font-size: 2.5rem
  margin-bottom: 10px
  opacity: 0.9

.login-title
  font-size: 1.3rem
  font-weight: 600
  margin-bottom: 5px

.login-subtitle
  font-size: 0.85rem
  opacity: 0.9
  margin-bottom: 0

.close-btn
  position: absolute
  top: 15px
  right: 15px
  background: rgba(255, 255, 255, 0.2)
  border: none
  color: white
  width: 35px
  height: 35px
  border-radius: 50%
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  transition: background 0.3s ease

.close-btn:hover
  background: rgba(255, 255, 255, 0.3)

.login-body
  padding: 20px 25px
  flex: 1
  overflow-y: auto

.login-form
  .form-group
    margin-bottom: 15px

  .form-label
    font-weight: 600
    color: #495057
    margin-bottom: 6px
    display: flex
    align-items: center
    font-size: 0.9rem

  .form-control
    border: 2px solid #e9ecef
    border-radius: 10px
    padding: 10px 12px
    font-size: 0.9rem
    transition: border-color 0.3s ease, box-shadow 0.3s ease

  .form-control:focus
    border-color: #667eea
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25)

  .form-control:disabled
    background-color: #f8f9fa
    opacity: 0.6

  .input-group
    .btn-outline-secondary
      border: 2px solid #e9ecef
      border-left: none
      border-radius: 0 10px 10px 0
      padding: 10px 12px
      transition: all 0.3s ease

    .btn-outline-secondary:hover
      background-color: #6c757d
      border-color: #6c757d
      color: white

.form-actions
  margin-top: 15px

.btn-login
  width: 100%
  padding: 11px
  border-radius: 10px
  font-weight: 600
  font-size: 0.95rem
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border: none
  transition: transform 0.3s ease, box-shadow 0.3s ease

.btn-login:hover:not(:disabled)
  transform: translateY(-2px)
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4)

.btn-login:disabled
  background: #6c757d
  cursor: not-allowed
  transform: none
  box-shadow: none

.login-footer
  margin-top: 15px
  text-align: center
  padding-top: 15px
  border-top: 2px solid #e9ecef

.btn-recover
  color: #667eea
  text-decoration: none
  font-size: 1rem
  padding: 10px 15px
  border: none
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)
  border-radius: 8px
  transition: all 0.3s ease
  font-weight: 600
  display: inline-flex
  align-items: center
  justify-content: center
  width: 100%
  gap: 8px

.btn-recover:hover:not(:disabled)
  color: white
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  transform: translateY(-2px)
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3)

.btn-recover:disabled
  color: #6c757d
  cursor: not-allowed
  opacity: 0.5
  background: #f8f9fa

/* Responsividade */
@media (max-width: 576px)
  .login-modal-overlay
    padding-top: 20px

  .login-modal-content
    width: 95%

  .login-header
    padding: 15px

  .login-body
    padding: 20px 15px

  .login-icon
    font-size: 2rem

  .login-title
    font-size: 1.2rem

  .login-subtitle
    font-size: 0.8rem

/* Animações de loading */
.fa-spinner
  animation: spin 1s linear infinite

@keyframes spin
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)
</style>
